import Notifications from "../../components/Notifications";

export default function NotificationsPage() {
    return (
        <Notifications />
    )
};